import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import router from './router/index'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import { iniciar as iniciarControleDeSessao } from './plugins/sessao'
Vue.config.productionTip = false

//
// Seis telas chamam this.$toast, mas o plugin nunca foi registrado: $toast
// era undefined e cada chamada virava TypeError. Em RelatorioViagens e
// RelatorioErrosMdfe isso engolia o redirecionamento para /login no 401 -
// o erro estourava antes do $router.push, deixando o usuario na tela sem
// mensagem nenhuma.
//
// bottom-right e nao o top-right padrao da biblioteca: o v-app-bar tem o
// menu do usuario no canto superior direito, e o toast ficaria em cima dele.
//
Vue.use(Toast, {
  position: 'bottom-right',
  maxToasts: 4,
  newestOnTop: true
})

// Controle de sessao (ociosidade, teto e renovacao) vive aqui, fora da arvore
// de componentes: antes morava no Header.vue, que e montado condicionalmente e
// reiniciava a contagem a cada remontagem.
iniciarControleDeSessao()

new Vue({
  router,
  store,
  render: h => h(App),
  vuetify
}).$mount('#app')
